import React, { Component } from 'react';
import PropTypes from 'prop-types';

import storeLoader from 'app/stores/storeLoader';
import formConsumer from 'core/form/formConsumer';
import Box from 'core/components/Box';

import NotificationUsageList from 'app/views/settings/notifications/NotificationUsageList';

@storeLoader(
  '$notifications.supportedChannels',
  '$alerting.policyCollection',
  '$mitigations.methodsCollection',
  '$syn.tests',
  '$mkp.tenants'
)
@formConsumer
export default class NotificationUsage extends Component {
  static propTypes = {
    model: PropTypes.object.isRequired
  };

  render() {
    const { model, role } = this.props;
    const ariaProps = {};

    if (role) {
      ariaProps.role = role;
    }

    return (
      <Box mb={1} {...ariaProps}>
        <NotificationUsageList asTable notificationModel={model} addDeleteColumn />
      </Box>
    );
  }
}
